/**
 * 版本号格式化工具
 * 将十进制版本号转换为十六进制格式
 * 例：65536 → 0x00010000
 */

/**
 * 格式化版本号为十六进制字符串
 * @param version 十进制版本号
 * @returns 十六进制格式，如 0x00010000
 */
export function formatVersion(version: number): string {
  return `0x${version.toString(16).toUpperCase().padStart(8, '0')}`
}

/**
 * 解析十六进制版本号
 * @param versionStr 十六进制字符串，如 0x00010000
 * @returns 十进制数字
 */
export function parseVersion(versionStr: string): number {
  if (versionStr.toLowerCase().startsWith('0x')) {
    return parseInt(versionStr.slice(2), 16)
  }
  return parseInt(versionStr, 10)
}
